module.exports = __webpack_public_path__ + "front/img/logo-1.62a39102.png";